/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateMeetingTemplateParticipantDto } from '../models/work-create-meeting-template-participant-dto';
import { WorkMeetingTemplateParticipant } from '../models/work-meeting-template-participant';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkUpdateMeetingTemplateParticipantDto } from '../models/work-update-meeting-template-participant-dto';

@Injectable({ providedIn: 'root' })
export class WorkMeetingTemplateParticipantsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `meetingTemplateParticipantsV2ControllerFindAllPaginated()` */
  static readonly MeetingTemplateParticipantsV2ControllerFindAllPaginatedPath = '/v2/meeting-template-participants';

  /**
   * Required permissions: meeting-types:read, meeting-types:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingTemplateParticipantsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingTemplateParticipantsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 1000
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by meetingTypeId query param.
     *           <p>
     *              <b>Format: </b> filter.meetingTypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.meetingTypeId=$not:$like:John Doe&filter.meetingTypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.meetingTypeId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> id:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC'>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkMeetingTemplateParticipant>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'meetingTypeId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingTemplateParticipantsV2Service.MeetingTemplateParticipantsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.meetingTypeId', params['filter.meetingTypeId'], {});
      rb.query('sortBy', params.sortBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkMeetingTemplateParticipant>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'meetingTypeId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: meeting-types:read, meeting-types:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingTemplateParticipantsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingTemplateParticipantsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 1000
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by meetingTypeId query param.
     *           <p>
     *              <b>Format: </b> filter.meetingTypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.meetingTypeId=$not:$like:John Doe&filter.meetingTypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.meetingTypeId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> id:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC'>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkMeetingTemplateParticipant>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'meetingTypeId'?: (string | Array<string>);
};
};
}> {
    return this.meetingTemplateParticipantsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkMeetingTemplateParticipant>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'meetingTypeId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkMeetingTemplateParticipant>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'meetingTypeId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `meetingTemplateParticipantsV2ControllerCreate()` */
  static readonly MeetingTemplateParticipantsV2ControllerCreatePath = '/v2/meeting-template-participants';

  /**
   * Required permissions: meeting-types:update, meeting-types:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingTemplateParticipantsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingTemplateParticipantsV2ControllerCreate$Response(
    params: {
      body: WorkCreateMeetingTemplateParticipantDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeetingTemplateParticipant>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingTemplateParticipantsV2Service.MeetingTemplateParticipantsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeetingTemplateParticipant>;
      })
    );
  }

  /**
   * Required permissions: meeting-types:update, meeting-types:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingTemplateParticipantsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingTemplateParticipantsV2ControllerCreate(
    params: {
      body: WorkCreateMeetingTemplateParticipantDto
    },
    context?: HttpContext
  ): Observable<WorkMeetingTemplateParticipant> {
    return this.meetingTemplateParticipantsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeetingTemplateParticipant>): WorkMeetingTemplateParticipant => r.body)
    );
  }

  /** Path part for operation `meetingTemplateParticipantsV2ControllerFindOneById()` */
  static readonly MeetingTemplateParticipantsV2ControllerFindOneByIdPath = '/v2/meeting-template-participants/{id}';

  /**
   * Required permissions: meeting-types:read, meeting-types:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingTemplateParticipantsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingTemplateParticipantsV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeetingTemplateParticipant>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingTemplateParticipantsV2Service.MeetingTemplateParticipantsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeetingTemplateParticipant>;
      })
    );
  }

  /**
   * Required permissions: meeting-types:read, meeting-types:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingTemplateParticipantsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingTemplateParticipantsV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkMeetingTemplateParticipant> {
    return this.meetingTemplateParticipantsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeetingTemplateParticipant>): WorkMeetingTemplateParticipant => r.body)
    );
  }

  /** Path part for operation `meetingTemplateParticipantsV2ControllerDelete()` */
  static readonly MeetingTemplateParticipantsV2ControllerDeletePath = '/v2/meeting-template-participants/{id}';

  /**
   * Required permissions: meeting-types:update, meeting-types:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingTemplateParticipantsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingTemplateParticipantsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeetingTemplateParticipant>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingTemplateParticipantsV2Service.MeetingTemplateParticipantsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeetingTemplateParticipant>;
      })
    );
  }

  /**
   * Required permissions: meeting-types:update, meeting-types:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingTemplateParticipantsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingTemplateParticipantsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkMeetingTemplateParticipant> {
    return this.meetingTemplateParticipantsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeetingTemplateParticipant>): WorkMeetingTemplateParticipant => r.body)
    );
  }

  /** Path part for operation `meetingTemplateParticipantsV2ControllerUpdate()` */
  static readonly MeetingTemplateParticipantsV2ControllerUpdatePath = '/v2/meeting-template-participants/{id}';

  /**
   * Required permissions: meeting-types:update, meeting-types:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingTemplateParticipantsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingTemplateParticipantsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateMeetingTemplateParticipantDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeetingTemplateParticipant>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingTemplateParticipantsV2Service.MeetingTemplateParticipantsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeetingTemplateParticipant>;
      })
    );
  }

  /**
   * Required permissions: meeting-types:update, meeting-types:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingTemplateParticipantsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingTemplateParticipantsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateMeetingTemplateParticipantDto
    },
    context?: HttpContext
  ): Observable<WorkMeetingTemplateParticipant> {
    return this.meetingTemplateParticipantsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeetingTemplateParticipant>): WorkMeetingTemplateParticipant => r.body)
    );
  }

}
